module.exports = __webpack_public_path__ + "2bb4a86d.png";